import { Editor } from "react-draft-wysiwyg";
// import { EditorState, convertToRaw } from "draft-js";
// import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

export default function RichTextEditor({ editorState, setEditorState }) {
    return (
        <div style={{ marginTop: "1rem" }}>
            <label className="form-label mb-8 h6">Feature & Design (Deskripsi HTML):</label>
            <Editor
                editorState={editorState}
                onEditorStateChange={setEditorState}
                wrapperClassName="wysiwyg-wrapper"
                editorClassName="wysiwyg-editor"
                toolbar={{
                    options: ["inline", "blockType", "fontSize", "list", "textAlign", "link", "emoji", "image", "history"],
                }}
            />
        </div>
    );
}
